import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const LINKS = [
  { view: "countries", label: "Страны" },
  { view: "cities", label: "Города" },
  { view: "categories", label: "Категории" },
];

// Restore the original editorial geography line rather than CTA-style buttons.
// The original approved hero imagery and typography are not modified.
export default function ProfessionalMapHeroLinks({ section = "" }) {
  return (
    <nav aria-label="Поиск по странам, городам и категориям"
      data-testid="professional-map-hero-discovery-links"
      className="mt-5 flex flex-wrap items-center gap-x-1 gap-y-0.5 text-[11px] uppercase tracking-[0.12em] text-[#816B5A]">
      <MapPin className="mr-1 h-3.5 w-3.5 shrink-0" strokeWidth={1.4} aria-hidden="true" />
      {LINKS.map(({ view, label }, i) => (
        <span key={view} className="inline-flex items-center gap-1">
          {i > 0 && <span aria-hidden="true">·</span>}
          <Link
            to={`/professional-map/discover?view=${view}${section ? "&section=" + encodeURIComponent(section) : ""}`}
            className="cursor-pointer rounded-sm text-inherit underline decoration-[#816B5A]/55 decoration-[1px] underline-offset-4 transition-colors hover:text-[#49372C] hover:decoration-[#49372C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#765944]"
            data-testid={`pm-discovery-link-${view}`}>
            {label}
          </Link>
        </span>
      ))}
    </nav>
  );
}
